import { z } from 'zod';
import { ValidatorUtils } from '../utils/ValidatorUtils';
import { AgentsStringSchema, CampaignEnumSchema, Market, MarketEnumSchema } from './sharedSchemas';

export const PublicAttributesSchema = z.object({
    campaign: CampaignEnumSchema,
    market: MarketEnumSchema.optional().default(Market.enUS),
    origin: z.string().url().max(256)
        .transform((s) => ValidatorUtils.sanitizeString(s)),
    resumeToken: z.string().min(100).max(400)
        .transform((s) => ValidatorUtils.sanitizeString(s))
        .optional(),
    enableSurvey: z.boolean().default(true),
    enableLiveChat: z.boolean().default(true),
    enableAgents: AgentsStringSchema.optional(),
    // TODO: remove enableSherlock after hosting sites migrate
    enableSherlock: z.boolean().default(false),
});

export const UnauthedAccessRequestSchema = z.object({
    attributes: PublicAttributesSchema,
});
